// eslint-disable-next-line import/prefer-default-export
export const TIME_RANGE_DEFINITIONS = {
  DEFAULT: 'DEFAULT',
  MOST_RECENT_DAYS: 'MOST_RECENT_DAYS',
  ONLY_START_DATE: 'ONLY_START_DATE',
  START_DATE_END_DATE: 'START_DATE_END_DATE',
};
